import React, { useState } from 'react';
import HorizontalBarCard from 'src/App/Dashboards/Market/Components/Cards/HorizontalBar';
import { parseGuest } from 'src/utils/functions';

const TopCountriesCard = ({
  graph,
  isDisabled,
  handleOnSampleClick,
  matches,
  userTailorMarketAccess,
  tooltipSuffix,
  warningTextComponent,
  setSelectedGraphExportDetails,
}: {
  graph;
  isDisabled: boolean;
  handleOnSampleClick: any;
  matches: boolean;
  userTailorMarketAccess: boolean;
  tooltipSuffix?: string;
  warningTextComponent: any;
  setSelectedGraphExportDetails: any;
}) => {
  const GRAPH_LIMIT = 5;
  const [graphLimit, setGraphLimit] = useState<number>(GRAPH_LIMIT);
  const dummyData = {
    'United States': 15.1,
    France: 15.1,
    Germany: 10.7,
    Australia: 8.6,
    Canada: 5.9,
    Switzerland: 4.7,
    'New Zealand': 3.3,
    Spain: 3.3,
    Ireland: 3.0,
    Netherlands: 3.0,
  };

  const onCTAClick = () => {
    setGraphLimit(prevLimit => (prevLimit === GRAPH_LIMIT ? -1 : GRAPH_LIMIT));
  };

  return (
    <>
      <HorizontalBarCard
        title="Top Guest Origin Countries"
        data={isDisabled ? dummyData : parseGuest(graph.data?.guest_origin?.countries)}
        color="#58C0A9"
        unit="%"
        isDisabled={isDisabled}
        handleOnSampleClick={handleOnSampleClick}
        graphLimit={graphLimit}
        onCTAClick={onCTAClick}
        matches={matches}
        userTailorMarketAccess={userTailorMarketAccess}
        tooltipSuffix={tooltipSuffix}
        parent="guest_origin_countries"
        warningTextComponent={warningTextComponent}
        setSelectedGraphExportDetails={setSelectedGraphExportDetails}
      />
    </>
  );
};

export default TopCountriesCard;
